module.exports = __webpack_public_path__ + "img/greentick.594ad237.svg";